export function normalizeCategory(row) {
  if (!row) return null;
  return {
    id: row.id ?? row.ID ?? '',
    parent_id: row.parent_id ?? row.parentId ?? row.ParentID ?? '',
    name: row.name ?? row.Name ?? '',
    slug: row.slug ?? row.Slug ?? '',
    description: row.description ?? row.Description ?? '',
    path: row.path ?? row.Path ?? '',
    display_order: row.display_order ?? row.displayOrder ?? row.DisplayOrder ?? 0,
    status: row.status ?? row.Status ?? 'ACTIVE',
    metadata: row.metadata ?? row.Metadata ?? {},
    created_at: row.created_at ?? row.createdAt ?? row.CreatedAt ?? '',
    updated_at: row.updated_at ?? row.updatedAt ?? row.UpdatedAt ?? '',
  };
}

export function normalizeCategoryTreeNode(node) {
  if (!node) return null;
  const base = normalizeCategory(node);
  const children = (node.children ?? node.Children ?? [])
    .map(normalizeCategoryTreeNode)
    .filter(Boolean);
  return { ...base, children };
}

export function normalizeAttributeSpec(row) {
  if (!row) return null;
  const values = (row.values ?? row.Values ?? []).map((v) => ({
    id: v.id ?? v.ID ?? '',
    value: v.value ?? v.Value ?? '',
    display_order: v.display_order ?? v.displayOrder ?? v.DisplayOrder ?? 0,
  }));
  return {
    id: row.id ?? row.ID ?? '',
    name: row.name ?? row.Name ?? '',
    type: row.type ?? row.Type ?? 'text',
    values,
    created_at: row.created_at ?? row.createdAt ?? '',
    updated_at: row.updated_at ?? row.updatedAt ?? '',
  };
}

export function slugifyName(name) {
  return String(name || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function flattenCategoryTree(tree, depth = 0, parentName = '') {
  const out = [];
  (tree || []).forEach((node) => {
    const label = parentName ? `${parentName} / ${node.name}` : node.name;
    out.push({ ...node, depth, label });
    if (node.children?.length) {
      out.push(...flattenCategoryTree(node.children, depth + 1, label));
    }
  });
  return out;
}

export function buildCategoryLabelMap(tree) {
  const map = new Map();
  flattenCategoryTree(tree).forEach((node) => {
    if (node.id) {
      map.set(node.id, node.label || node.name || node.id);
    }
  });
  return map;
}

export function getCategoryBreadcrumbLabel(category, labelById) {
  if (!category) return '';
  if (category.label) return category.label;
  const fromMap = labelById?.get(category.id);
  if (fromMap) return fromMap;
  return category.name || category.id || '';
}
